import React from 'react'
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/input/containers/input.container';


export default function VehicleCategoryBasicInfoComponent({ handleBasicFormChange, selectedVehicleCategory }: any) {
  return (
    <>
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer

              label="Category Name"
              name="UsageCategory"
              onValueChange={(event: any) => {
                handleBasicFormChange(
                  event.target.value,
                  'LogisticsVehicleCategoryName'

                )
              }}
              type="text"
              value={selectedVehicleCategory?.LogisticsVehicleCategoryName}
            />
            <InputContainer
              label="Registration Category"
              name="VehicleCategoryRegistration"
              onValueChange={(event: any) => {
                handleBasicFormChange(
                  event.target.value,
                  'VehicleCategoryRegistration'

                )
              }}
              type="text"
              value={selectedVehicleCategory?.VehicleCategoryRegistration}
            />
            <InputContainer
              label="Vehicle Type"
              name="VehicleCategoryType"
              onValueChange={(event: any) => {
                handleBasicFormChange(
                  event.target.value,
                  'VehicleCategoryType'

                )
              }}
              type="text"
              value={selectedVehicleCategory?.VehicleCategoryType}
            />
            <InputContainer
              label="Body Type"
              name="VehicleCategoryBodyType"
              onValueChange={(event: any) => {
                handleBasicFormChange(
                  event.target.value,
                  'VehicleCategoryBodyType'

                )
              }}
              type="text"
              value={selectedVehicleCategory?.VehicleCategoryBodyType}
            />
            <InputContainer
              label="Fuel Type"
              name="VehicleCategoryFuelType"
              onValueChange={(event: any) => {
                handleBasicFormChange(
                  event.target.value,
                  'VehicleCategoryFuelType'

                )
              }}
              type="text"
              value={selectedVehicleCategory?.VehicleCategoryFuelType}
            />
             <InputContainer
            
                          label="Trip Base Price"
                          name="Price"
                          onValueChange={(event: any) => {
                            handleBasicFormChange(
                              event.target.value,
                              'TripVehicleBasePrice'
            
                            )
                          }}
                          type="number"
                          value={selectedVehicleCategory?.TripVehicleBasePrice}
                        />
            <InputContainer
              label="Emission Standard"
              name="VehicleEmissionStandard"
              onValueChange={(event: any) => {
                handleBasicFormChange(
                  event.target.value,
                  'VehicleEmissionStandard'

                )
              }}
              type="text"
              value={selectedVehicleCategory?.VehicleEmissionStandard}
            />
            <InputContainer
              label="Axle Configuration"
              name="VehicleAxleConfiguration"
              onValueChange={(event: any) => {
                handleBasicFormChange(
                  event.target.value,
                  'VehicleAxleConfiguration'

                )
              }}
              type="text"
              value={selectedVehicleCategory?.VehicleAxleConfiguration}
            />


            <div className='col-span-full'>
              <InputContainer

                label="Description"
                name="Description"
                onValueChange={(event: any) => {
                  handleBasicFormChange(
                    event.target.value,
                    'Description'

                  )
                }}
                type="text"
                value={selectedVehicleCategory?.Description}
              />
            </div>
          </div>
        }
        expandedPanel="basicInfo"
        headerTitle="Basic Information"
      />
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              label="Min Loading Capacity(kg)"
              name="MinWeight"
              onValueChange={(event: any) => {
                handleBasicFormChange(
                  event.target.value,
                  'MinimumLoadingCapacity'

                )
              }}
              type="number"
              value={selectedVehicleCategory?.MinimumLoadingCapacity}
            />
            <InputContainer
              label="Max Loading Capacity(kg)"
              name="MaximumLoadingCapacity"
              onValueChange={(event: any) => {
                handleBasicFormChange(
                  event.target.value,
                  'MaximumLoadingCapacity'

                )
              }}
              type="number"
              value={selectedVehicleCategory?.MaximumLoadingCapacity}
            />

          </div>
        }
        expandedPanel="loadCapacityInfo"
        headerTitle="Load Capacity Information"
      />
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              label="Length(meters)"
              name="Length"
              onValueChange={(event: any) => {
                handleBasicFormChange(
                  event.target.value,
                  'Length'

                )
              }}
              type="number"
              value={selectedVehicleCategory?.Length}
            />
            <InputContainer
              label="Width(meters)"
              name="Width"
              onValueChange={(event: any) => {
                handleBasicFormChange(
                  event.target.value,
                  'Width'

                )
              }}
              type="number"
              value={selectedVehicleCategory?.Width}
            />
            <InputContainer
              label="Height(meters)"
              name="Height"
              onValueChange={(event: any) => {
                handleBasicFormChange(
                  event.target.value,
                  'Height'

                )
              }}
              type="number"
              value={selectedVehicleCategory?.Height}
            />
          </div>
        }
        expandedPanel="dimensionsInfo"
        headerTitle="Dimensions Information"
      />
      <AccordionContainer
        child={
          <div className=' grid grid-cols-1 gap-4'>
            <InputContainer
              label="Special Equipment"
              onValueChange={(newValue: any) => {
                const benefitData: any = newValue.map((option: any) => option?.id || '')
                handleBasicFormChange(
                  benefitData,
                  'VehicleSpecialEquipment'

                );
              }}
              type="multiselectText"
              value={selectedVehicleCategory?.VehicleSpecialEquipment}
            />


          </div>
        }
        expandedPanel="specialEquipment"
        headerTitle="Special Equipment Information"
      />
    </>
  )
}